'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _adapters = require('./adapters');

var metaPropertyAdapters = _interopRequireWildcard(_adapters);

var _storageKeys = require('../storageKeys');

var _helpers = require('../common/helpers');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _hamplitudeProperties = null;

var getStaticProperties = (0, _helpers.once)(function () {
  var staticProperties = {
    windowWidth: -1,
    windowHeight: -1,
    screenWidth: -1,
    screenHeight: -1,
    lastPageUrl: ''
  };

  if (window) {
    staticProperties.windowWidth = window.innerWidth;
    staticProperties.windowHeight = window.innerHeight;
  }

  if (screen) {
    staticProperties.screenWidth = screen.width;
    staticProperties.screenHeight = screen.height;
  }

  if (document) {
    staticProperties.lastPageUrl = document.referrer;
  }

  return staticProperties;
});

var getDefaultHamplitudeProperties = function getDefaultHamplitudeProperties(currentTime) {
  return {
    device_id: (0, _helpers.makeUuid)(),
    last_event_id: 0,
    last_sequence_number: 0,
    last_timestamp_checked_against_session: currentTime,
    session_id: currentTime
  };
};

var getHamplitudeProperties = function getHamplitudeProperties(getTempStorage, currentTime) {
  var hamplitudeProperties = _hamplitudeProperties;

  if (!hamplitudeProperties) {
    hamplitudeProperties = getTempStorage(_storageKeys.hamplitudeKey);
    if (!hamplitudeProperties) {
      hamplitudeProperties = getDefaultHamplitudeProperties(currentTime);
    } else {
      hamplitudeProperties = JSON.parse(hamplitudeProperties);
    }
  }

  return hamplitudeProperties;
};

var setHamplitudeProperties = function setHamplitudeProperties(setTempStorage, hamplitudeProperties) {
  _hamplitudeProperties = hamplitudeProperties;
  setTempStorage(_storageKeys.hamplitudeKey, JSON.stringify(hamplitudeProperties));
};

var get = exports.get = function get(_ref) {
  var getTempStorage = _ref.getTempStorage,
      setTempStorage = _ref.setTempStorage;

  var currentTime = Date.now();
  var staticProperties = getStaticProperties();
  var hamplitudeProperties = metaPropertyAdapters.refreshHamplitudeProperties(getHamplitudeProperties(getTempStorage, currentTime), currentTime);

  setHamplitudeProperties(setTempStorage, hamplitudeProperties);

  return _extends({}, hamplitudeProperties, staticProperties, {
    timestamp: currentTime
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.76/js/metaProperties/index.js
// module id = 403
// module chunks = 0